export enum InfoMessage {
  adding_products = 'Adding products...',
  loading_history = 'Loading order history...',
  loading_rewards = 'Loading rewards...',
  enter_phone = 'Enter phone number to view order history',
  close_location = 'This location is closed. Please order from another location.',
  store_closed = 'Store closed',
  product_unavailable = 'Product unavailable',
  any_product_unavailable= 'One or more products is no longer available and products cannot be reordered.',
  enter_phone_for_loyalty = 'Enter phone number to view loyalty account'
}
